<template>
  <Layout footer>
    <NSpin :show="initLoading" :class="{ 'py-40': initLoading }">
      <div class="app-container" v-if="!initLoading">
        <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
          <span class="mr-1">当前位置：</span>
          <NBreadcrumb>
            <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
            <NBreadcrumbItem>学习中心</NBreadcrumbItem>
            <NBreadcrumbItem>考评评审</NBreadcrumbItem>
          </NBreadcrumb>
        </div>
        <div class="mt-7 p-10 border border-gray-300">
          <div class="relative flex items-start pb-28 border-b-2 border-dashed border-gray-300">
            <n-button type="primary" class="ml-auto absolute top-0 right-0">{{
              msg
            }}</n-button>
            <img style="width: 225px" class="flex-shrink-0" :src="imgBaseUrl + userInfo.photo" alt="头像信息" />
            <div class="ml-20 pr-10 w-full">
              <p class="text-xl">{{ userInfo.stuName }}</p>
              <p class="mt-4 text-gray-500 text-base"> 机构：{{ userInfo.tenantName }} </p>
              <p class="mt-2 text-gray-500 text-base">班级：{{ userInfo.className }}</p>
              <p class="mt-2 text-gray-500 text-base">班主任：{{ userInfo.headTeacherName }}</p>
              <div class="flex flex-wrap mt-10 space-x-3 w-full" v-if="content.length > 0">
                <div v-for="(item, index) in content" :key="index">
                  <p class="text-xl flex items-center">
                    <span>{{ item.name }}</span>
                    <img v-if="!(index === content.length - 1)" class="ml-4" style="width: 120px"
                      src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/step-arrow.png" alt="" />
                  </p>
                  <div class="mt-2 text-gray-400">
                    <p>{{ item.desc }}</p>
                    <p>{{ item.date }}</p>
                  </div>
                </div>
                <!--<div>-->
                <!--  <p class="text-xl flex items-center">-->
                <!--    <span>评审材料上传</span>-->
                <!--    <img-->
                <!--      class="ml-4"-->
                <!--      style="width: 120px"-->
                <!--      src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/step-arrow.png"-->
                <!--      alt=""-->
                <!--    />-->
                <!--  </p>-->
                <!--  <div class="mt-2 text-gray-400">-->
                <!--    <p>共 16 页，已上传 16 页</p>-->
                <!--    <p>2021-03-19 15:50:44</p>-->
                <!--  </div>-->
                <!--</div>-->
                <!--<div>-->
                <!--  <p class="text-xl flex items-center">-->
                <!--    <span>审核中</span>-->
                <!--    <img-->
                <!--      class="ml-4"-->
                <!--      style="width: 120px"-->
                <!--      src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/step-arrow.png"-->
                <!--      alt=""-->
                <!--    />-->
                <!--  </p>-->
                <!--  <div class="mt-2 space-y-1 text-gray-400">-->
                <!--    <p>共 16 页，驳回 0 页</p>-->
                <!--    <p>2021-03-19 15:50:44</p>-->
                <!--  </div>-->
                <!--</div>-->
                <!--<div>-->
                <!--  <p class="text-xl flex items-center">-->
                <!--    <span>评审中</span>-->
                <!--    <img-->
                <!--      class="ml-4"-->
                <!--      style="width: 120px"-->
                <!--      src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/step-arrow.png"-->
                <!--      alt=""-->
                <!--    />-->
                <!--  </p>-->
                <!--  <div class="mt-2 space-y-1 text-gray-400">-->
                <!--    <p>评审开始 2020-03-18</p>-->
                <!--    <p>预计 2021-03-19 日评审完毕</p>-->
                <!--  </div>-->
                <!--</div>-->
                <!--<div>-->
                <!--  <p class="text-xl flex items-center">-->
                <!--    <span>评审完毕</span>-->
                <!--  </p>-->
                <!--  <div class="mt-2 space-y-1 text-gray-400">-->
                <!--    <p>合格情况：合格</p>-->
                <!--    <p>祁秀荣70.0分，王友治77.0分</p>-->
                <!--    <p> 2021年1月1日 8：00：00</p>-->
                <!--  </div>-->
                <!--</div>-->
              </div>
            </div>
          </div>
          <div class="inline-block mt-4 py-1 text-xl border-b-2 border-dashed border-gray-300">
            考评评审
          </div>
          <div class="flex items-center justify-center mb-8 mt-14">
            <div class="qrcode text-center">
              <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhihuirencai/type___jumpProspectus.png" alt="二维码" />
              <p>认考评评审二维码</p>
            </div>
            <p class="ml-8">
              请使用
              <span style="color: #ea4c00">智慧人才APP</span>
              扫描教材领用二维码进行材料下载、上传、查看
            </p>
          </div>
        </div>
      </div>
    </NSpin>
  </Layout>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Layout from '@/components/Layout';
import { computed, reactive, ref } from 'vue';
import { getUserInfoApi, businessPlanStatusApi } from '@/api';

const router = useRouter();
function gotoHome () {
  router.push('/');
}

const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';
const userInfo = reactive({});
const initLoading = ref(true);
getUserInfoApi()
  .then(res => res.data)
  .then(res => {
    const { photo, stuName, tenantName, className, headTeacherName } = res;
    Object.assign(userInfo, {
      photo,
      stuName,
      tenantName,
      className,
      headTeacherName,
    });
  })
  .finally(() => (initLoading.value = false));

const content = ref([]);
const msg = computed(() => {
  if (content.value.length === 0) {
    return '未上传';
  }
  if (content.value.length === 1) {
    if (content.value[0].desc === '未绑定创业计划书') {
      return '未上传';
    }
  }
  return '已上传';
});
businessPlanStatusApi().then(res => {
  content.value = res.data;
});
</script>

<style lang="scss" scoped>
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}

.qrcode > img {
  width: 170px;
  height: 176px;
  margin-bottom: 5px;
}
</style>
